import axios from '../javascript/custom-axios'

export default { 
  uploadFile(body){
    return axios.post(`/upload`, body)
  },
}